export const requestTypes = {
    PATCH: 'patch',
    POST: 'post',
    GET: 'get',
};
